import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'

const UnfilledSVG: SVGFC = ({ color, ...props }) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2188 14.0508C17.3708 14.0508 18.3698 14.0508 19.0304 14.0508C19.3292 14.0508 19.6154 13.9323 19.826 13.7214C20.0375 13.5105 20.1563 13.2243 20.1554 12.9259C20.1563 11.3094 20.1563 7.79249 20.1563 6.17595C20.1563 5.87761 20.0375 5.59143 19.826 5.3805C19.6154 5.16958 19.3292 5.05078 19.0304 5.05078C16.6067 5.05078 9.64246 5.05078 7.21876 5.05078C6.91996 5.05078 6.63376 5.16958 6.42316 5.3805C6.21166 5.59143 6.09286 5.87761 6.09376 6.17595C6.09376 6.4888 6.09376 6.87319 6.09376 7.30078C6.09376 7.45602 6.21975 7.58224 6.37455 7.58224C6.52936 7.58224 6.65626 7.45602 6.65626 7.30078C6.65626 6.87319 6.65626 6.4888 6.65626 6.17595C6.65536 6.02678 6.71476 5.88369 6.82096 5.77806C6.92626 5.67276 7.06936 5.61337 7.21876 5.61337C9.64246 5.61337 16.6067 5.61337 19.0304 5.61337C19.1798 5.61337 19.3229 5.67276 19.4282 5.77806C19.5344 5.88369 19.5938 6.02678 19.5938 6.17595C19.5938 7.79249 19.5938 11.3094 19.5929 12.9259C19.5938 13.0751 19.5344 13.2182 19.4282 13.3235C19.3229 13.4291 19.1798 13.4885 19.0304 13.4885C18.3698 13.4885 17.3708 13.4885 16.2188 13.4885C16.0631 13.4885 15.9371 13.6144 15.9371 13.7697C15.9371 13.9249 16.0631 14.0508 16.2188 14.0508Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.875 7.30185H17.625C17.7804 7.30185 17.9062 7.17582 17.9062 7.02055C17.9062 6.86528 17.7804 6.73926 17.625 6.73926H10.875C10.7196 6.73926 10.5938 6.86528 10.5938 7.02055C10.5938 7.17582 10.7196 7.30185 10.875 7.30185ZM10.875 8.98935H17.625C17.7804 8.98935 17.9062 8.86332 17.9062 8.70805C17.9062 8.55278 17.7804 8.42676 17.625 8.42676H10.875C10.7196 8.42676 10.5938 8.55278 10.5938 8.70805C10.5938 8.86332 10.7196 8.98935 10.875 8.98935ZM10.875 10.6768H17.625C17.7804 10.6768 17.9062 10.5508 17.9062 10.3956C17.9062 10.2403 17.7804 10.1143 17.625 10.1143H10.875C10.7196 10.1143 10.5938 10.2403 10.5938 10.3956C10.5938 10.5508 10.7196 10.6768 10.875 10.6768ZM5.25 19.6765C4.87706 19.6765 4.51931 19.5283 4.2555 19.2648C3.99197 19.001 3.84375 18.6432 3.84375 18.2703C3.84375 17.3531 3.84375 16.0287 3.84375 14.8953C3.84375 13.5801 4.84669 12.4993 6.12947 12.3758C6.50691 12.8793 6.98503 13.2078 7.5 13.2078C8.01244 13.2078 8.48887 12.8824 8.86547 12.3826C9.76884 12.4821 10.5898 12.976 11.1003 13.7416L11.2415 13.9536L14.8066 11.8147C14.9798 11.7107 15.1958 11.7079 15.3716 11.8074C15.5474 11.907 15.6562 12.0937 15.6562 12.2957C15.6562 12.3474 15.6562 12.4892 15.6562 12.6253C15.6562 12.8132 15.5623 12.9887 15.4059 13.093C14.6935 13.568 12.6601 14.9282 11.9572 15.4437C11.4808 15.793 10.837 15.8074 10.3454 15.4797L9.46875 14.8953V18.8328C9.46875 19.0566 9.37988 19.2712 9.22153 19.4293C9.06347 19.5876 8.84888 19.6765 8.625 19.6765H5.8125V15.1765C5.8125 15.0213 5.6865 14.8953 5.53125 14.8953C5.376 14.8953 5.25 15.0213 5.25 15.1765V19.6765Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 8.14502C8.43122 8.14502 9.1875 8.9013 9.1875 9.83252C9.1875 10.7637 8.43122 12.645 7.5 12.645C6.56878 12.645 5.8125 10.7637 5.8125 9.83252C5.8125 8.9013 6.56878 8.14502 7.5 8.14502Z"
      fill={color}
    />
  </svg>
)

const FilledSvg: SVGFC = ({ color, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.0312 13.0781H6.46875C5.69339 13.0781 5.0625 12.4472 5.0625 11.6719V2.67188C5.0625 1.89651 5.69339 1.26562 6.46875 1.26562H16.0312C16.8066 1.26562 17.4375 1.89651 17.4375 2.67188V11.6719C17.4375 12.4472 16.8066 13.0781 16.0312 13.0781ZM6.46875 1.82812C6.00348 1.82812 5.625 2.2066 5.625 2.67188V11.6719C5.625 12.1371 6.00348 12.5156 6.46875 12.5156H16.0312C16.4965 12.5156 16.875 12.1371 16.875 11.6719V2.67188C16.875 2.2066 16.4965 1.82812 16.0312 1.82812H6.46875Z"
      fill={color}
    />
    <path
      d="M8.15625 16.4531H1.40625C1.09559 16.4531 0.84375 16.2013 0.84375 15.8906C0.84375 13.716 2.60663 11.9531 4.78125 11.9531C6.95587 11.9531 8.71875 13.716 8.71875 15.8906C8.71875 16.2013 8.46691 16.4531 8.15625 16.4531Z"
      fill={color}
    />
    <path
      d="M8.15625 16.7344H1.40625C0.940978 16.7344 0.5625 16.3559 0.5625 15.8906C0.5625 13.5643 2.4549 11.6719 4.78125 11.6719C7.1076 11.6719 9 13.5643 9 15.8906C9 16.3559 8.62152 16.7344 8.15625 16.7344ZM4.78125 12.2344C2.76526 12.2344 1.125 13.8746 1.125 15.8906C1.125 16.0458 1.25107 16.1719 1.40625 16.1719H8.15625C8.31143 16.1719 8.4375 16.0458 8.4375 15.8906C8.4375 13.8746 6.79724 12.2344 4.78125 12.2344Z"
      fill={color}
    />
    <path
      d="M2.53125 16.7344C2.37579 16.7344 2.25 16.6086 2.25 16.4531V15.6094C2.25 15.4539 2.37579 15.3281 2.53125 15.3281C2.68671 15.3281 2.8125 15.4539 2.8125 15.6094V16.4531C2.8125 16.6086 2.68671 16.7344 2.53125 16.7344ZM7.03125 16.7344C6.87579 16.7344 6.75 16.6086 6.75 16.4531V15.6094C6.75 15.4539 6.87579 15.3281 7.03125 15.3281C7.18671 15.3281 7.3125 15.4539 7.3125 15.6094V16.4531C7.3125 16.6086 7.18671 16.7344 7.03125 16.7344Z"
      fill="black"
    />
    <path d="M5.90625 14.7656H3.65625L4.78125 11.6719L5.90625 14.7656Z" fill={color} />
    <path
      d="M5.90614 15.047H3.65614C3.46732 15.0521 3.32187 14.8458 3.39192 14.6696C3.39192 14.6696 4.51692 11.5759 4.51692 11.5759C4.5959 11.3337 4.96642 11.3331 5.04536 11.5759C5.04536 11.5759 6.17036 14.6696 6.17036 14.6696C6.24011 14.8456 6.09524 15.0524 5.90614 15.047ZM4.05769 14.4845H5.50459L4.78114 12.4949L4.05769 14.4845Z"
      fill="black"
    />
    <path
      d="M12.6562 13.9219H9.84375C9.53309 13.9219 9.28125 13.67 9.28125 13.3594V12.7969H13.2188V13.3594C13.2188 13.67 12.9669 13.9219 12.6562 13.9219Z"
      fill="#EFEFEF"
    />
    <path
      d="M12.6562 14.2031H9.84375C9.37848 14.2031 9 13.8246 9 13.3594V12.7969C9 12.6414 9.12579 12.5156 9.28125 12.5156H13.2188C13.3742 12.5156 13.5 12.6414 13.5 12.7969V13.3594C13.5 13.8246 13.1215 14.2031 12.6562 14.2031ZM9.5625 13.0781V13.3594C9.5625 13.5146 9.68857 13.6406 9.84375 13.6406H12.6562C12.8114 13.6406 12.9375 13.5146 12.9375 13.3594V13.0781H9.5625Z"
      fill={color}
    />
    <path
      d="M11.25 15.3281C11.0945 15.3281 10.9688 15.2023 10.9688 15.0469V13.9219C10.9688 13.7664 11.0945 13.6406 11.25 13.6406C11.4055 13.6406 11.5312 13.7664 11.5312 13.9219V15.0469C11.5312 15.2023 11.4055 15.3281 11.25 15.3281Z"
      fill={color}
    />
    <path
      d="M11.8125 15.6096C11.7937 16.3514 10.7062 16.3513 10.6875 15.6096C10.7063 14.8677 11.7938 14.8679 11.8125 15.6096Z"
      fill={color}
    />
    <path
      d="M11.2499 16.4531C10.1373 16.424 10.1375 14.7946 11.2499 14.7656C12.3625 14.7948 12.3622 16.4241 11.2499 16.4531ZM11.2499 15.3281C10.8803 15.3346 10.8803 15.8842 11.2499 15.8906C11.6195 15.8842 11.6195 15.3345 11.2499 15.3281Z"
      fill={color}
    />
    <path
      d="M13.4998 4.64062H8.99979C8.63148 4.63495 8.62896 4.08433 8.9998 4.07812H13.4998C13.8681 4.0838 13.8706 4.63442 13.4998 4.64062ZM14.3435 6.60938H8.15604C7.78832 6.60387 7.78473 6.05313 8.15605 6.04688H14.3435C14.7113 6.05238 14.7149 6.60312 14.3435 6.60938ZM12.9373 8.57812H9.56229C9.40684 8.57812 9.28104 8.45233 9.28104 8.29688C9.28104 8.14142 9.40684 8.01562 9.56229 8.01562H12.9373C13.306 8.02142 13.3078 8.57195 12.9373 8.57812ZM14.0623 10.5469H8.43729C8.06895 10.5412 8.06648 9.99058 8.4373 9.98438H14.0623C14.4302 9.98994 14.4334 10.5406 14.0623 10.5469ZM7.59354 9.14062C7.59354 10.6939 6.33434 11.9531 4.78104 11.9531C1.05031 11.805 1.05138 6.4757 4.78106 6.32812C6.33434 6.32813 7.59354 7.58732 7.59354 9.14062Z"
      fill={color}
    />
    <path
      d="M4.78125 12.2345C3.07535 12.2345 1.6875 10.8467 1.6875 9.14075C1.85744 5.03647 7.70569 5.03766 7.87501 9.14077C7.875 10.8467 6.48715 12.2345 4.78125 12.2345ZM4.78125 6.6095C3.38544 6.6095 2.25 7.74494 2.25 9.14075C2.38893 12.4988 7.17408 12.4978 7.31251 9.14073C7.3125 7.74494 6.17706 6.6095 4.78125 6.6095Z"
      fill={color}
    />
  </svg>
)

const TeachingIcon: SVGFC = ({
  color = tailwindColors.purple.DEFAULT,
  filled,
  isIconFilled,
  ...props
}) => {
  const shouldFill = filled || isIconFilled

  return (
    <>
      {shouldFill ? (
        // TODO: need to change FilledSvg
        <FilledSvg color={color} {...props} />
      ) : (
        <UnfilledSVG color={color} {...props} />
      )}
    </>
  )
}

export default TeachingIcon
